import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquareMore, Send } from "lucide-react";
import { STATUS_META } from "@/lib/workflow";
import { toast } from "sonner";

export const InfoRequestPanel = ({ v, canRespond, busy, onSubmit }) => {
  const [text, setText] = useState(v.additional_info || "");
  const back = STATUS_META[v.info_return_stage]?.label || v.info_return_stage;
  const submit = () => {
    if (!text.trim()) return toast.error("Additional Info is required");
    onSubmit(text.trim());
  };
  return (
    <div className="no-print rounded-lg border border-amber-200 bg-amber-50 dark:bg-amber-950/40 dark:border-amber-900 px-4 py-3 space-y-3" data-testid="info-request-banner">
      <div className="flex items-start gap-2 text-sm text-amber-800 dark:text-amber-300">
        <MessageSquareMore className="w-4 h-4 mt-0.5 shrink-0" />
        <span data-testid="info-request-note">
          <strong>Additional Info Requested.</strong> {v.info_request_note}
          {v.info_requested_by ? ` — by ${v.info_requested_by}` : ""}
          <span className="block text-xs opacity-80 mt-0.5">Once submitted, the voucher returns to {back}.</span>
        </span>
      </div>
      {canRespond && (
        <div className="space-y-2">
          <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={4}
            placeholder="Add the requested information…" className="bg-white dark:bg-slate-900" data-testid="additional-info-input" />
          <div className="flex justify-end">
            <Button className="gap-2" disabled={busy} onClick={submit} data-testid="submit-info-btn">
              <Send className="w-4 h-4" /> Submit Info
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
